import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=02397dba&scoped=true&"
import script from "./Frame.vue?vue&type=script&lang=js&"
export * from "./Frame.vue?vue&type=script&lang=js&"
import style0 from "./Frame.vue?vue&type=style&index=0&id=02397dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02397dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02397dba')) {
      api.createRecord('02397dba', component.options)
    } else {
      api.reload('02397dba', component.options)
    }
    module.hot.accept("./Frame.vue?vue&type=template&id=02397dba&scoped=true&", function () {
      api.rerender('02397dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/DashboardApp/Frame.vue"
export default component.exports